/* eslint-disable react/no-danger */
import type { GatsbySSR, GatsbyBrowser } from 'gatsby';
import React from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import { GlobalLoaderProvider } from './src/context/GlobalLoaderContext';
import { MyAccountProvider } from './src/context/MyAccountContext';
import { msalConfig, partnerMsalConfig } from './src/authConfig.mjs';

// Create the MSAL instances outside the component tree to prevent them from being re-instantiated on re-renders.
const customerMsalInstance = new PublicClientApplication(msalConfig);
const partnerMsalInstance = new PublicClientApplication(partnerMsalConfig);

// Initialize both MSAL instances
customerMsalInstance.initialize();
partnerMsalInstance.initialize();

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] &
  GatsbySSR['wrapRootElement'] = ({ element }) => (
  <MyAccountProvider
    customerInstance={customerMsalInstance}
    partnerInstance={partnerMsalInstance}
  >
    <GlobalLoaderProvider>{element}</GlobalLoaderProvider>
  </MyAccountProvider>
);

export const onRenderBody: GatsbySSR['onRenderBody'] = ({
  setHeadComponents,
}) => {
  setHeadComponents([
    <script
      key="partytown-vanilla-config"
      dangerouslySetInnerHTML={{
        __html: `partytown = { debug: false }`,
      }}
    />,
  ]);
};
